import React, { useCallback, useEffect, useState } from "react";
import LineChart from "components/Chart/LineChart";
import BarChart from "components/Chart/BarChart";
import PieChart from "components/Chart/PieChart";
import { BarChartTransformer, pieChartTransformer } from "module/services/chart.transformer";
import "./style.css"

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardFooter,
  Row,
  Col,
} from "reactstrap";

import { ResultApi, WarehouseApi } from "module/services/services";

function Dashboard(props) {
  const lineId = 9130

  const bars = [
    { id: 99, type: 'v', col: 6 },
    { id: 101, type: 'h', col: 6 },
    { id: 105, type: 'v', col: 6 },
    { id: 106, type: 'v', col: 6 },
    { id: 109, type: 'h', col: 6 },
    { id: 112, type: 'v', col: 6 },
  ]

  const reports = [lineId]
  bars.map(b => reports.push(b.id));

  const [data, setData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const color = ['Purple', 'red', 'blue', 'green']

  const getData = useCallback(async () => {
    const result = await ResultApi(reports)
    await setData(result?.data);
    await setLoaded(true);
  })

  useEffect(() => {
    getData()
  }, [])
  return (
    <>
      {loaded === false ? null : (
        <div className="content">
          <Row>
            <Col md="6" xs="12">
              <Card className="card-chart">
                <CardHeader>
                  <Row>
                    <Col className="text-right" sm="6">
                      <CardTitle tag="h5">تعداد کل طلاق‌ های ثبت شده در کشور</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <LineChart
                      datasets={data.find(i => i.id === lineId).trend}
                      label="title"
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md="6" xs="12">
              <Row>
                <Col md="6" xs="12">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col xs="5">
                          <div class="info-icon text-center icon-warning">
                            <i class="tim-icons icon-chat-33"></i>
                          </div>
                        </Col>
                        <Col xs="7">
                          <div class="numbers">
                            <p class="card-category">رکوردها</p>
                            <h3 class="card-title">5000+</h3>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr /><div class="stats text-right"><i class="tim-icons icon-refresh-01"></i> آخرین بروزرسانی</div>
                    </CardFooter>
                  </Card>
                </Col>
                <Col md="6" xs="12">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col xs="5">
                          <div class="info-icon text-center icon-success">
                            <i class="tim-icons icon-single-02"></i>
                          </div>
                        </Col>
                        <Col xs="7">
                          <div class="numbers">
                            <p class="card-category">کاربران</p>
                            <h3 class="card-title">100+</h3>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr /><div class="stats text-right"><i class="tim-icons icon-trophy"></i> فعال</div>
                    </CardFooter>
                  </Card>
                </Col>
                <Col md="6" xs="12">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col xs="5">
                          <div class="info-icon text-center icon-primary">
                            <i class="tim-icons icon-shape-star"></i>
                          </div>
                        </Col>
                        <Col xs="7">
                          <div class="numbers">
                            <p class="card-category">تعداد</p>
                            <h3 class="card-title">50+</h3>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr /><div class="stats text-right"><i class="tim-icons icon-chart-pie-36"></i> موضوعات</div>
                    </CardFooter>
                  </Card>
                </Col>
                <Col md="6" xs="12">
                  <Card className="card-stats">
                    <CardBody>
                      <Row>
                        <Col xs="5">
                          <div class="info-icon text-center icon-danger">
                            <i class="tim-icons icon-molecule-40"></i>
                          </div>
                        </Col>
                        <Col xs="7">
                          <div class="numbers">
                            <p class="card-category">گزارشات</p>
                            <h3 class="card-title">19</h3>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardFooter>
                      <hr /><div class="stats text-right"><i class="tim-icons icon-sound-wave"></i> تعیین کننده ها</div>
                    </CardFooter>
                  </Card>
                </Col>
              </Row>
            </Col>
            {bars.map((b, i) => (
              <Col lg={b.col}>
                <Card className="card-chart">
                  <CardHeader>
                    <CardTitle tag="h4">
                      <h5 className="card-category text-right">
                        <i className="tim-icons icon-bell-55 text-info" />&nbsp;
                        {data.find(i => i.id === b.id).title}
                      </h5>
                    </CardTitle>
                  </CardHeader>
                  <CardBody>
                    <div className="chart-area">
                      {b.type === 'p' ?
                        (<PieChart
                          data={pieChartTransformer(data.find(i => i.id === b.id).values[0].values, "description")}
                        />) :
                        (<BarChart
                          data={BarChartTransformer(data.find(i => i.id === b.id).values[0].values, "description", color[i])}
                          type={b.type}
                        />)}
                    </div>
                  </CardBody>
                </Card>
              </Col>))}
          </Row>
        </div>
      )}
    </>
  );
}

export default Dashboard;
